module.exports = __webpack_public_path__ + "static/media/bg.7de6bd73.png";